import { SolidViewLayoutManager } from "@solidstarters/solid-core-ui";

const LineLocationFieldHandler = async (event: any) => {
    const { modifiedField, formData, viewMetadata, modifiedFieldValue } = event;

    
    const layout = viewMetadata.layout;
    const layoutManager = new SolidViewLayoutManager(layout);

    const userTypeValue = modifiedField === 'userType' 
        ? modifiedFieldValue?.value 
        : formData.userType?.value;

        
    if (userTypeValue === 'Bond Cancellation Admin' || formData.userType === "Bond Cancellation Admin") {
        layoutManager.updateNodeAttributes('line', { required: false });
        layoutManager.updateNodeAttributes('location', { required: false });
    } else {
        layoutManager.updateNodeAttributes('line', { required: true });
        layoutManager.updateNodeAttributes('location', { required: true });
    }

    return {
        layoutChanged: true,
        dataChanged: false, 
        newLayout: layoutManager.getLayout()
    };
}

export default LineLocationFieldHandler;